import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const VisualizerDriftFrequencyListItem = (props) => {
    const { speed, updateVisualizerSettings } = props;

    const onSpeedChange = (value) => updateVisualizerSettings({ drift: { speed: value } });

    return (
        <SliderListItem
            title='Speed'
            displayMultiplier={50}
            value={speed}
            min={0}
            max={100}
            step={1}
            onValueChange={onSpeedChange}
        />
    );
};

const mapStateToProps = (state) => {
    const drift = state.createPreview.present.videoSettings.visualizer.drift;
    return { speed: drift?.speed ?? 1 };
};

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerDriftFrequencyListItem);
